import { defineStore } from "pinia";
import { ref, computed } from "vue";
import Kodo from "@/model/kodo.js";

export const useResourceStore = defineStore("resource", () => {
  const resources = ref(new Map());
  const loading = new Set(); // 不再是 ref

  const loadResource = async (url) => {
    if (loading.has(url)) return;

    try {
      loading.add(url);
      const cached = localStorage.getItem(url);

      if (cached) {
        resources.value.set(url, cached);
        return;
      }

      const cdnUrl = await Kodo.getCdnUrl(url);
      const response = await fetch(cdnUrl);
      const blob = await response.blob();

      const base64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });

      localStorage.setItem(url, base64);
      resources.value.set(url, base64);
    } catch (error) {
      console.error("Load resource error:", error);
    } finally {
      loading.delete(url);
    }
  };

  const backgroundImage = computed(() => {
    const url = "background.png";
    if (!resources.value.has(url)) {
      loadResource(url);
    }
    return resources.value.get(url) || "";
  });

  const logoNewImage = computed(() => {
    const url = "logo-new.png";
    if (!resources.value.has(url)) {
      loadResource(url);
    }
    return resources.value.get(url) || "";
  });

  return {
    backgroundImage,
    logoNewImage,
  };
});
